export const buildSignedUrlEndpoint = (
  baseUrl: string,
  params: {
    domain: string;
    widgetId: string;
    path?: string;
    transport?: "websocket" | "webrtc";
  }
): string => {
  const url = new URL(`${baseUrl}/api/signed-url`);
  url.searchParams.set("domain", params.domain);
  url.searchParams.set("widgetId", params.widgetId);
  if (params.path) {
    url.searchParams.set("path", params.path);
  }
  if (params.transport) {
    url.searchParams.set("transport", params.transport);
  }
  return url.toString();
};

export const getCurrentDomain = (): string => {
  return window.location.hostname;
};

export const getCurrentPath = (): string => {
  return window.location.pathname;
};
